import * as React from "react"
import { Outlet, useNavigate } from "react-router-dom"

import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer"

import AppBarItems from "../../components/AppBar/AppBarItems"
import AppBar from "../../components/AppBarWithDrawer/AppBar"
import Drawer from "../../components/AppBarWithDrawer/Drawer"
import DarkModeToggle from "../../components/DarkModeToggle"
import { useAppSelector } from "../../redux"
import AccountListItems from "./AccountListItems"
import {
  Alert,
  Box,
  Button,
  Divider,
  IconButton,
  Link,
  List,
  Stack,
  Toolbar,
  useMediaQuery,
} from "@podcastsoundboard/ps-lib/ui"
import ChevronLeftIcon from "@podcastsoundboard/ps-lib/ui/icons/ChevronLeft"
import ChevronRightIcon from "@podcastsoundboard/ps-lib/ui/icons/ChevronRight"

const Account: React.FC = () => {
  const navigate = useNavigate()
  const currentUserProfile = useAppSelector((state) => state.currentUserProfile)
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)
  const [open, setOpen] = React.useState<boolean>(true)
  const toggleDrawer = () => {
    setOpen(!open)
  }

  React.useEffect(() => {
    if (!currentUserProfile) navigate("/app/signin")
  }, [currentUserProfile, navigate])

  const isLargeScreen = useMediaQuery("(min-width: 1440px)")

  React.useEffect(() => {
    setOpen(isLargeScreen)
  }, [isLargeScreen])

  const hasActiveStripeSubscription =
    currentUserProfile && currentUserProfile.hasActiveStripeSubscription

  return (
    <>
      <Box className="flex bg-appbg h-screen">
        <AppBar position="absolute" open={open}>
          <Toolbar className="pr-[24px]">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              className={open ? "hidden" : "mr-9"}
            >
              <ChevronRightIcon />
            </IconButton>
            <Box className="grow" />
            {!hasActiveStripeSubscription && (
              <Button
                style={{ color: "white", borderColor: "white" }}
                className="mr-4"
                variant="outlined"
                onClick={() => navigate("/app/account/subscription")}
              >
                Trial Mode
              </Button>
            )}

            <DarkModeToggle />
            <AppBarItems />
          </Toolbar>
        </AppBar>

        <Drawer variant="permanent" open={open} className="hide-scrollbar">
          <Toolbar className="flex items-center justify-start px-2">
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>

          <Divider />

          <List className="pt-0">
            <AccountListItems open={open} />
          </List>
        </Drawer>

        <Box
          component="main"
          className="grow flex flex-col items-stretch justify-start mobile-have-min-width"
        >
          <Toolbar />

          {currentUserProfile &&
            !currentUserProfile.hasActiveStripeSubscription && (
              <React.Fragment>
                <Stack className="w-full" spacing={2}>
                  <Alert severity="warning" className="rounded-none">
                    <Link
                      href="/app/account/subscription"
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        e.preventDefault()
                        navigate("/app/account/subscription")
                      }}
                    >
                      Your account is in trial mode.
                    </Link>{" "}
                    You are limited to three sounds per soundboard, and can't
                    create more than one soundboard. <br />
                    Purchase a web subscription for the full cloud experience
                    plus access to the Windows app!
                  </Alert>
                </Stack>
                <Divider />
              </React.Fragment>
            )}

          <PageContainer
            darkModeEnabled={darkModeEnabled}
            style={{ overflow: "auto", minHeight: "auto" }}
          >
            <Outlet />
          </PageContainer>
        </Box>
      </Box>
    </>
  )
}

export default Account
